import { EnvType } from './type';

export const environment: EnvType = {
  name: 'Trs',
  apis: {
    API_DACTECH_BACK_ROOT: 'https://api.trs.dalkia.fr/dactech_back',
    API_EQUIPES: 'https://api.trs.dalkia.fr/dactech_back/v1/uos',
    API_NOTIFICATION: 'https://api.trs.dalkia.fr/notifications-mobile/v1',
    API_AGENDA_OT: 'https://api.trs.dalkia.fr/dactech_back/v1/agenda',
    API_CHECK_CONNEXION_URL: 'https://api.trs.dalkia.fr/dactech_back/v1/supervision/health',
    API_ACTIVITES: 'https://api.trs.dalkia.fr/dactech_back/v1/ots',
    API_CR: 'https://api.trs.dalkia.fr/dactech_back/v1/crs',
    API_DACTECH_BACK: 'https://api.trs.dalkia.fr/dactech_back',
    API_DACTECH_BACK_V1: 'https://api.trs.dalkia.fr/dactech_back/v1',
    API_DOCUMENT_PATRIMOINES: 'https://api.trs.dalkia.fr/dactech_back/v1/documentPatrimoines',
    API_CONTACTS: 'https://api.trs.dalkia.fr/dactech_back/v1/contacts',
    API_SITE: 'https://api.trs.dalkia.fr/dactech_back/v1/sites',
    API_CRT_IOT: 'http://localhost:10000/api',
    API_PORTEFEUILLE: 'https://api.trs.dalkia.fr/dactech_back/v1/portefeuille',
    API_AGENDA_EQUIPE_V2: 'https://api.trs.dalkia.fr/dactech_back/v1/agenda/equipe',
    RESET_PASSWORD: 'https://dalkia.service-now.com/$pwd_reset.do?sysparm_url=ad_reset',
    API_DEMANDE_TRAVAUX: 'https://api.trs.dalkia.fr/dactech_back/v1/demandeTravaux',
    API_ACCUSE_RECEPTION: 'https://api.trs.dalkia.fr/dactech_back/v1/accuseReception',
  },
  appId: 'com.dalkia.dactechtrsbeta',
  appName: 'D@cTech TRS Beta',
  appVersion: require('../../package.json').version,
  fullAppVersion: 'Ionic 7 v' + require('../../package.json').version + ' - Trs',
  production: false,
  mockAuthentification: false,
  redirectUrlCapacitorNormal: 'dactech-trs-beta://authentification',
  redirectUrlCapacitorSensible: 'dactech-trs-beta://authentification-sensible',
  redirectUrlModifyAdfsPassword: 'https://auth.eti.dalkia.fr/adfs/portal/updatepassword',
  oidcConf: {
    normal: {
      clientId: '2gllnc3jats5bba74k7nn6d177',
      clientSecret: 'c38e2upal603l7msjollh8c4qe09b4tsojqg4qn6bqieh2fqfhr',
      idpIdentifier: 'dkadfsetiv4',
      authWellknownEndpoints: {
        authorizationEndpoint: 'https://dk-dactech-hp.auth.eu-west-1.amazoncognito.com/oauth2/authorize',
        tokenEndpoint: 'https://dk-dactech-hp.auth.eu-west-1.amazoncognito.com/oauth2/token',
      },
    },
    sensitive: {
      clientId: '5k8gp8b542cjp1487irech3eg7',
      clientSecret: '10sh7rk424q7h5jqhk7krjlbscordjilf3enq3crvjnhm71ng875',
      idpIdentifier: 'dkadfsetiv4',
      authWellknownEndpoints: {
        authorizationEndpoint: 'https://dk-crtmobilesec-hp.auth.eu-west-1.amazoncognito.com/oauth2/authorize',
        tokenEndpoint: 'https://dk-crtmobilesec-hp.auth.eu-west-1.amazoncognito.com//oauth2/token',
      },
    },
  },
  logLevel: 4,
  firebase: {
    apiKey: 'AIzaSyB_1yOqkzT8ijB4i32yOKRACudtBHYdfU4',
    authDomain: 'dactech-6c991.firebaseapp.com',
    databaseURL: 'https://dactech-6c991.firebaseio.com',
    projectId: 'dactech-6c991',
    storageBucket: 'dactech-6c991.appspot.com',
    messagingSenderId: '571801177583',
    appId: '1:571801177583:web:ce114131c534699b483a1a',
  },
  desactivateCRTAndIOT: false,
  datadog: {
    logEnvironment: 'trs',
    rumEnabled: false,
    sessionSampleRate: 0,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    defaultPrivacyLevel: 'mask-user-input',
    datadogLogsClientToken: 'pub867b6da2cc275ab88edb74988e65ad45',
    datadogLogsSite: 'datadoghq.eu',
    datadogLogsSessionSampleRate: 100,
  },
  hotlineNumber: '+33698260586',
  supportChatUrl: 'https://chat.google.com/room/AAQAROtNRWg?',
  aleriskUrl: 'https://dalkia-portail.deltarm.com',
};
